const translationJep = {
    "Introduction": "Introduction",
    "is an internationalization-framework which offers a complete solution to localize your product from web to mobile and desktop": "is an internationalization-framework which offers a complete solution to localize your product from web to mobile and desktop",
    "Plugins to detect the user language": "Plugins to detect the user language",
    "Plugins to load translations": "Plugins to load translations",
    "Optionally cache the translations": "Optionally cache the translations",
    "Advantages": "Advantages",
    "Flexibility to use other packages": "Flexibility to use other packages",
    "Welcome": "ようこそ",
    "WelcomeText": "Großartig, wenn Sie diese Seite sehen. OIDC wurde erfolgreich eingerichtet",
    "ProfileSettings": "プロファイル設定",
    "ApplicationSettings":"アプリの設定",
    "ChangePassword":"パスワードを変更する",
    "Logout":"ログアウト"
}

export default translationJep